/* eslint-disable no-restricted-globals */
import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        module: '.rfct-filter-toggle',
        openButton: '.rfct-filter-toggle__button-container .rfct-button',
        closeButton: '.rfct-filter-toggle__close-button',
    },
    classNames: {
        active: 'rfct-filter-toggle--active',
    },
};

export default class FilterToggle {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = this._getDomElements();
        this._active = this._$rootElement.hasClass(config.classNames.active);
    }

    _getDomElements() {
        return {
            $openButton: this._$rootElement.find(config.selectors.openButton),
            $closeButton: this._$rootElement.find(config.selectors.closeButton),
        };
    }

    init() {
        this._addEventListeners();
        this._setActive(this._active);
    }

    _addEventListeners() {
        this._elements.$openButton.on('click', () => {
            this._setActive(true);
        });

        this._elements.$closeButton.on('click', () => {
            this._setActive(false);
        });
    }

    _setActive(active) {
        this._active = active;

        if (this._active) {
            this._$rootElement.addClass(config.classNames.active);
        } else {
            this._$rootElement.removeClass(config.classNames.active);
        }
    }
}

moduleRegistry.registerModule('FilterToggle', FilterToggle);
moduleRegistry.autoApplyModule('FilterToggle', config.selectors.module);
